import { useState, useRef, useEffect } from 'react';
import './CustomSelect.css';

export default function CustomSelect({ options, value, onChange, placeholder }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const selected = options.find((o) => o === value) || placeholder || options[0];

  return (
    <div className={`custom-select${open ? ' open' : ''}`} ref={ref}>
      <button type="button" className="cs-trigger" onClick={() => setOpen(!open)}>
        <span className="cs-value">{selected}</span>
        <svg className="cs-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      <div className="cs-dropdown">
        <ul className="cs-list">
          {options.map((opt) => (
            <li
              key={opt}
              className={`cs-option${opt === value ? ' selected' : ''}`}
              onClick={() => { onChange(opt); setOpen(false); }}
            >
              {opt === value && (
                <svg className="cs-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              )}
              <span>{opt}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
